import { IEndpointConfiguration } from '@kurtosys/types/api/common/IEndpointConfiguration.js';

import { KsysRequest } from './KsysRequest.js';

export class RawRequest<TRequestBody, TResponseBody> extends KsysRequest<TRequestBody, TResponseBody> {
	getExplicitEndpoint = (): string => '';
	get endpointConfiguration(): IEndpointConfiguration<any> {
		return undefined;
	}
}
